enum KnownErrorCodes {
    NetworkError = -20
}
export { KnownErrorCodes };
